import React from 'react'
import { Image } from 'react-native'

import {
  B1,
  B5,
  H1,
  Icon,
  SH1,
  SH2,
  SH3,
  Stack,
  XStack,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import moment from 'moment'
import { AnimatedCircularProgress } from 'react-native-circular-progress'

import { crifLogo, experianLogo } from '../../../assets'
import { getCreditLevel } from '../../utils/constants'

interface ICreditScoreCircleInfo {
  name: string
  bureau: string
  creditScore: number
  handleInfoPress: () => void
  bureauReportFetchDate: string
}

const CreditScoreCircleInfo = ({
  name,
  bureau,
  creditScore,
  handleInfoPress,
  bureauReportFetchDate,
}: ICreditScoreCircleInfo) => {
  return (
    <Stack className="bg-grays-20 items-center pt-3" style={{ height: 330 }}>
      <SH2 className="text-grays-80 mb-3">
        {i18n.t('checkCreditScore.creditScoreTitle', { name })}
      </SH2>
      <Stack>
        <Image
          source={bureau === 'CRIF' ? crifLogo : experianLogo}
          style={{
            height: 100,
            width: 70,
            position: 'absolute',
            left: 100,
            top: -10,
          }}
          resizeMode="contain"
        />
      </Stack>
      <AnimatedCircularProgress
        size={220}
        width={15}
        backgroundWidth={15}
        fill={creditScore / 10}
        tintColor="#ED8C71"
        tintColorSecondary="#FCE942"
        backgroundColor="#D1D9E9"
        arcSweepAngle={220}
        rotation={250}
        lineCap="round"
        duration={4000}
      />
      <Stack className="relative" style={{ top: '-45%' }}>
        <H1 className="text-center">{creditScore}</H1>
        <XStack className="items-center justify-center space-x-2">
          <SH1 className="text-grays-80">
            {getCreditLevel(creditScore, bureau)}
          </SH1>
          <Pressable onPress={handleInfoPress}>
            <Icon type="InfoOutlined" />
          </Pressable>
        </XStack>
      </Stack>
      <XStack
        className="relative items-center justify-between space-x-2"
        style={{ top: '-40%' }}
      >
        <Stack className="relative" style={{ left: '-65%' }}>
          <SH1 className="text-teritary-100 text-center">300</SH1>
          <SH3 className="text-warning-100">
            {i18n.t('checkCreditScore.poor')}
          </SH3>
        </Stack>
        <Stack className="relative" style={{ left: '75%' }}>
          <SH1 className="text-teritary-100 text-center">900</SH1>
          <SH3 className="text-success-100">
            {i18n.t('checkCreditScore.excellent')}
          </SH3>
        </Stack>
      </XStack>
      <Stack className="relative" style={{ top: '-35%' }}>
        <B5 className="text-grays-60">
          {i18n.t('checkCreditScore.reportDate')}
          <B1 className="text-grays-80">
            {moment(bureauReportFetchDate).format('DD-MMM-YYYY')}
          </B1>
        </B5>
      </Stack>
    </Stack>
  )
}

export default CreditScoreCircleInfo
